
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[mainSubpage]/[subcategory]",
      function () {
        return require("private-next-pages/[mainSubpage]/[subcategory]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[mainSubpage]/[subcategory]"])
      });
    }
  